var map = {
	"./de/header/criteria": [
		"KA/L",
		40
	],
	"./en/header/criteria": [
		"eiXn",
		24
	],
	"./fr/header/criteria": [
		"OVwk",
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "IwNl";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/header\/criteria$
// module id = IwNl
// module chunks = 70